import React, { useEffect, useRef } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
interface ConfirmDialogProps {
  title: string;
  description: string;
  items?: string[];
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}
export function ConfirmDialog({
  title,
  description,
  items = [],
  confirmLabel,
  onCancel,
  onConfirm
}: ConfirmDialogProps) {
  const confirmRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    confirmRef.current?.focus();
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onCancel]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-4" data-mp="2ors0lvz99njp">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onCancel} aria-hidden="true" data-id="element-5" data-mp="915sr8y3ei1m" />
      <div role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title" className="relative w-full max-w-md rounded bg-white p-5 shadow-xl" data-id="element-6" data-mp="42uiix3vy5iv">
        <div className="flex items-start gap-3" data-id="element-7" data-mp="a1g4sz7yp8sf">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-700" data-id="element-8" data-mp="f2dmlap280te">
            <AlertTriangleIcon className="h-5 w-5" aria-hidden="true" data-id="element-9" data-mp="k1gt6zkouf3h" />
          </span>
          <div data-id="element-10" data-mp="3ijcjildlnjpa">
            <h2 id="confirm-dialog-title" className="text-base font-semibold text-slate-900" data-id="element-11" data-mp="3ijvshcl9uxr6">
              {title}
            </h2>
            <p className="mt-1 text-sm text-slate-600" data-id="element-12" data-mp="3sha6z6nmxcgu">{description}</p>
          </div>
        </div>

        {items.length > 0 && <ul className="mt-4 max-h-40 space-y-1 overflow-y-auto rounded border border-slate-200 bg-slate-50 p-2 text-sm text-slate-700" data-id="element-13" data-mp="134hp76b0t4q">
            {items.map(item => <li key={item} className="truncate" data-id="element-14" data-mp="34qwg3jgsdjnu">
                {item}
              </li>)}
          </ul>}

        <div className="mt-5 flex justify-end gap-2" data-id="element-15" data-mp="2wp6wewoq6z2m">
          <button type="button" onClick={onCancel} className="rounded border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-2" data-id="element-16" data-mp="2spei03cnhypc">
            Cancel
          </button>
          <button ref={confirmRef} type="button" onClick={onConfirm} className="rounded bg-red-600 px-3 py-1.5 text-sm font-semibold text-white transition hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2" data-id="element-17" data-mp="2dtyllrollqps">
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>;
}